// === custom-video.js ===
// Robuster loader: setzt iframe.src wenn notwendig und sorgt für Carousel-Refresh nach Laden

document.addEventListener('DOMContentLoaded', function () {
  var iframes = document.querySelectorAll('.product-video-iframe');
  if (!iframes || iframes.length === 0) return;

  function refreshCarouselLayout() {
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  function loadIframe(iframe) {
    var dataSrc = iframe.getAttribute('data-src') || iframe.dataset.src;
    if (!dataSrc) {
      console.warn('product-video-iframe: kein data-src gefunden', iframe);
      return;
    }
    if (iframe.src === dataSrc) return;

    // setze src und wenn geladen wurde, triggern wir ein resize für das Carousel
    iframe.src = dataSrc;
    console.info('product-video-iframe: src gesetzt ->', dataSrc);

    iframe.addEventListener('load', function () {
      // kleine Verzögerung, damit der Player gerendert hat
      setTimeout(refreshCarouselLayout, 120);
    }, { once: true });
  }

  // 1) Wenn Slide die Klasse is-initial hat: sofort laden
  iframes.forEach(function (iframe) {
    var slide = iframe.closest('.product-gallery__media');
    if (slide && slide.classList.contains('is-initial')) {
      loadIframe(iframe);
    }
  });

  // 2) Wenn ein Thumbnail/Dot aria-current="true" hat und das Video referenziert
  var currentThumb = document.querySelector('.product-gallery__thumbnail[aria-current="true"], .page-dots button[aria-current="true"]');
  if (currentThumb) {
    var isVideoThumb = currentThumb.getAttribute('data-media-type') === 'video' || (currentThumb.getAttribute('data-media-id')||'').indexOf('video-') === 0;
    if (isVideoThumb) {
      var iframe = document.querySelector('.product-video-iframe');
      if (iframe) loadIframe(iframe);
    }
  }

  // 3) IntersectionObserver: lade wenn sichtbar (Fallback: sofort)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var iframe = entry.target;
        if (entry.isIntersecting) {
          loadIframe(iframe);
        }
      });
    }, { threshold: 0.6 });

    iframes.forEach(function (iframe) {
      io.observe(iframe);
    });
  } else {
    iframes.forEach(function (iframe) { loadIframe(iframe); });
  }

  // 4) Klicks auf Thumbnails / dots -> falls Video ausgewählt wird: setze src sofort
  function onThumbClick(e) {
    var btn = e.target.closest('button, .product-gallery__thumbnail, .product-gallery__thumbnail *');
    if (!btn) return;
    if (btn.tagName !== 'BUTTON') btn = btn.closest('button');
    if (!btn) return;

    var isVideo = btn.getAttribute('data-media-type') === 'video' || (btn.getAttribute('data-media-id')||'').indexOf('video-') === 0;
    if (isVideo) {
      var iframe = document.querySelector('.product-video-iframe');
      if (iframe) loadIframe(iframe);
    }
  }

  var thumbContainers = document.querySelectorAll('.product-gallery__thumbnail-scroller, .product-gallery__thumbnail-list, .page-dots, product-gallery-navigation, carousel-navigation');
  thumbContainers.forEach(function (container) {
    container.addEventListener('click', onThumbClick, false);
  });

  // 5) Safety: falls nicht automatisch geladen, versuche nach kurzer Zeit
  setTimeout(function () {
    var iframe = document.querySelector('.product-video-iframe');
    if (!iframe) return;
    if (!iframe.src || iframe.src === '') {
      var rect = iframe.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0) {
        loadIframe(iframe);
      }
    }
  }, 800);
});
